import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { api } from '../../context/AuthContext';
import { useToast } from '../../hooks/use-toast';

const FELDER = [['rueckruf', 'Rückrufe an'], ['registrierung', 'Registrierungen an'], ['mandatsanfrage', 'Mandatsanfragen an']];

export const ZuweisungsRegeln = () => {
  const { toast } = useToast();
  const [r, setR] = useState(null);
  const [team, setTeam] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get('/kanzlei/eingang/regeln').then((x) => setR(x.data)).catch(() => setR({}));
    api.get('/kanzlei/team').then((x) => setTeam((x.data.items || []).filter((p) => p.role !== 'freelancer'))).catch(() => {});
  }, []);
  const speichern = async () => {
    setBusy(true);
    try { const x = await api.put('/kanzlei/eingang/regeln', r); setR(x.data); toast({ title: 'Regeln gespeichert' }); }
    catch (e) { toast({ title: e?.response?.data?.detail || 'Speichern fehlgeschlagen', variant: 'destructive' }); }
    finally { setBusy(false); }
  };
  if (!r) return <Loader2 className="w-5 h-5 animate-spin text-[#b8893d]" />;
  return (
    <div className="space-y-4" data-testid="zuweisungs-regeln">
      <label className="flex items-start gap-3 text-sm text-[#1B3A5C]">
        <input type="checkbox" checked={r.akte_bearbeitung !== false} onChange={(e) => setR({ ...r, akte_bearbeitung: e.target.checked })} className="mt-1 w-4 h-4 accent-[#b8893d]" data-testid="regel-akte-bearbeitung" />
        <span>Vorgänge zu einem Mandanten an die Bearbeitung der Akte<span className="block text-xs text-gray-500">Nachrichten, Dokumente, Zahlungen und Widerrufe gehen an die Person, die in der Akte als Bearbeitung eingetragen ist.</span></span>
      </label>
      <div className="grid sm:grid-cols-3 gap-3">
        {FELDER.map(([k, label]) => (
          <label key={k} className="block text-xs text-gray-500">{label}
            <select value={r[k] || ''} onChange={(e) => setR({ ...r, [k]: e.target.value || null })} data-testid={`regel-${k}`}
              className="mt-1 w-full h-10 px-3 rounded-[10px] border border-gray-200 bg-white text-sm text-[#1B3A5C] focus:border-[#1B3A5C] focus:ring-2 focus:ring-[#e0b56a]/40 outline-none">
              <option value="">Offen (nicht zugewiesen)</option>
              {team.map((p) => <option key={p.user_id} value={p.user_id}>{p.name}</option>)}
            </select>
          </label>
        ))}
      </div>
      <p className="text-xs text-gray-500">Die Regeln greifen nur für Einträge ohne zuständige Person. Manuelles Übernehmen oder Zuweisen geht immer vor.</p>
      <button type="button" onClick={speichern} disabled={busy} data-testid="regeln-speichern" className="h-10 px-5 rounded-[10px] bg-[#1B3A5C] text-white text-sm hover:bg-[#2A5280] disabled:opacity-50 transition-colors">{busy ? 'Speichert …' : 'Regeln speichern'}</button>
    </div>
  );
};

export default ZuweisungsRegeln;
